type EvaluationRowLike = {
  tentativeId: string;
  statut: string;
  canStart: boolean;
  noteSur20: number | null;
  session: {
    statut: string;
    dateOuverture?: string | null;
  };
};

export type ApprenantEvaluationAction = {
  label: string;
  hint: string | null;
  openable: boolean;
};

export function resolveApprenantEvaluationAction(row: EvaluationRowLike): ApprenantEvaluationAction {
  if (row.statut === 'SOUMIS') {
    return {
      label: 'Voir ma copie',
      hint: row.noteSur20 != null ? `Note : ${row.noteSur20}/20` : 'Épreuve soumise',
      openable: true,
    };
  }

  if (row.canStart || row.statut === 'EN_COURS') {
    return {
      label: row.statut === 'EN_COURS' ? "Reprendre l'épreuve" : "Passer l'épreuve",
      hint: null,
      openable: true,
    };
  }

  if (row.statut === 'EXPIRE') {
    return {
      label: "Voir l'épreuve",
      hint: 'Le délai imparti est dépassé.',
      openable: true,
    };
  }

  if (row.session.statut === 'PUBLIEE') {
    const dateHint = row.session.dateOuverture
      ? `Ouverture prévue le ${new Date(row.session.dateOuverture).toLocaleString('fr-FR')}`
      : 'En attente du lancement par votre formateur.';
    return {
      label: "Voir l'épreuve",
      hint: dateHint,
      openable: true,
    };
  }

  if (row.session.statut === 'TERMINEE' || row.session.statut === 'ANNULEE') {
    return {
      label: "Voir l'épreuve",
      hint:
        row.session.statut === 'ANNULEE'
          ? 'Cette épreuve a été annulée.'
          : 'La fenêtre de cette épreuve est fermée.',
      openable: true,
    };
  }

  return {
    label: "Voir l'épreuve",
    hint: null,
    openable: true,
  };
}
